import {
  Button,
  FetchButton,
  Modal,
  PopupActions,
  WithLightTitle,
} from '@randstad-lean-mobile-factory/react-components-core';
import moment from 'moment';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { IllusWarning } from 'src/Assets';
import { FormStatusContext } from 'src/Hooks/Navigation/useFormNavigationContextElements';
import { FETCH_STATUS } from 'src/Redux/Types';
import { mergeFetchStatusWithFormState } from 'src/Services/Async';

import styles from './NavigationWarningModal.module.scss';
import { Props } from './NavigationWarningModal.types';

const NavigationWarningModal = ({ open, onClose }: Props) => {
  const innerRef = React.useRef<PopupActions>(null);
  const currentDate = moment();
  const history = useHistory();
  const {
    destination,
    fetchStatus,
    handleSubmit,
    setFormState,
    formState: { isSubmitting, isSubmitted, isSubmitSuccessful },
  } = useContext(FormStatusContext);
  const [isTouched, setIsTouched] = useState(true);
  return (
    <Modal
      open={open}
      title="attention"
      ref={innerRef}
      onClose={onClose}
      icon={<IllusWarning />}
      footerActionsRight={[
        <Button.Secondary
          onClick={() => {
            history.push(destination);
            onClose();
          }}
        >
          passer sans sauvegarder
        </Button.Secondary>,
        <FetchButton
          className={styles.fetchButton}
          fetchStatus={
            isTouched
              ? FETCH_STATUS.FULFILLED
              : mergeFetchStatusWithFormState(fetchStatus, {
                  isSubmitting,
                  isSubmitSuccessful,
                  isSubmitted,
                })
          }
          title="sauvegarder et changer"
          onClick={() => {
            setIsTouched(false);
            handleSubmit();
          }}
          onBeforeSuccessAnimation={() => {
            setFormState({ isSubmitSuccessful: false, isSubmitted: false, isSubmitting: false });
            setIsTouched(true);
            history.push(destination);
          }}
          onSuccess={() => {
            onClose();
          }}
          onError={() => {
            setFormState({ isSubmitSuccessful: false, isSubmitted: false, isSubmitting: false });
            setIsTouched(true);
            onClose();
          }}
        />,
      ]}
    >
      <WithLightTitle
        title={`le ${currentDate.format('L')} à ${currentDate.hours()}:${currentDate.minutes()}`}
      >
        <div className={styles.text}>
          Vous souhaitez changer de rubrique mais vos données ne sont pas sauvegardées
        </div>
      </WithLightTitle>
    </Modal>
  );
};

export default NavigationWarningModal;
